import React, { Component } from 'react';
import InputMask from 'react-input-mask';
import { DynamicMembershipForm } from './dynamic/DynamicMembershipForm.jsx';
import { ErrorMessage } from '../shared/ErrorMessage.jsx';
import { PersonSelect } from '../shared/PersonSelect.jsx';
import I18n from 'i18n-js';
import '../translations.js';
import DatePicker from "./datepicker/DatePicker.jsx";
export class NewPersonForm extends Component {

  constructor(props) {
    super(props);
    this.state = {
      firstName: this.props.userData.first_name || '',
      lastName: this.props.userData.last_name || '',
      dateOfBirth: '',
      email: '',
      password: '',
      confirmPassword: '',
      allowEmailing: true,
      phone: '',
      mobile: '',
      guardian1: '',
      guardian2: '',
      allowTexting: true,
      coachedBy: '',
      sponsoredBy: '',
      address1: '',
      address2: '',
      city: '',
      province: '',
      zipCode: '',
      initialForms: [],
      forms: [],
      memberships: [],
      showGuardianFields: false,
      createErrorMessage: false
    };
    this.onChange = this.onChange.bind(this);
    this.onCheck = this.onCheck.bind(this);
    this.checkFields = this.checkFields.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleAddForm = this.handleAddForm.bind(this);
    this.handleRemoveForm = this.handleRemoveForm.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
    this.listToSelectOption = this.listToSelectOption.bind(this);
    this.diabledForm = this.diabledForm.bind(this);
    this.handleDynamicFormNameChange = this.handleDynamicFormNameChange.bind(this);
    this.handleDynamicFormIdChange = this.handleDynamicFormIdChange.bind(this);
    this.handleCoachChange = this.handleCoachChange.bind(this);
    this.handleGuardianOneChange = this.handleGuardianOneChange.bind(this);
    this.handleGuardianTwoChange = this.handleGuardianTwoChange.bind(this);
  }

  componentWillReceiveProps(props) {
    var initialMemberships = []
    var initialForms = []
    if (this.props.usef) {
      initialMemberships = initialMemberships.concat([{name: "United States Equestrian Federation", number: this.props.usef}]),
      initialForms = initialForms.concat([this.diabledForm(1, "United States Equestrian Federation", this.props.usef)])
    }
    if (this.props.fei) {
      initialMemberships = initialMemberships.concat([{name: "Fédération Équestre Internationale", number: this.props.fei}]),
      initialForms = initialForms.concat([this.diabledForm(2, "Fédération Équestre Internationale", this.props.fei)])
    }
    if (this.props.ec) {
      initialMemberships = initialMemberships.concat([{name: "Equestrian Canada", number: this.props.ec}]),
      initialForms = initialForms.concat([this.diabledForm(3, "Equestrian Canada", this.props.ec)])
    }
    if (this.props.userData.date_of_birth) {
      var date = this.props.userData.date_of_birth.split('-').reverse().join('/')
      this.handleDateChange(date)
    }
    this.setState({ 
      memberships: initialMemberships,
      initialForms: initialForms
    });
  }

  diabledForm(id,name,number) {
    return  <div key={id} >
              <div className="control-group select optional user_equine_associations_name">
                <label className="select optional control-label">Organization</label>
                <div className="controls">
                   <input className="string optional" type="text" disabled={true} placeholder={name} />
                </div>
              </div>
              <div className="control-group string optional user_equine_associations_number">
                <label className="string optional control-label">Membership Number</label>
                <div className="controls">
                  <input className="string optional" type="text" disabled={true} placeholder={number} />
                </div>
              </div>
            </div>;
  }

  listToSelectOption(x) {
    return <option key={x}>{x}</option>
  }

  onChange(e) {
    const state = this.state;
    state[e.target.id] = e.target.value;
    this.setState(state);
  }

  handleDateChange(receivedAge) {
    var value = receivedAge;
    this.setState({ dateOfBirth: value });
    var date = new Date(value.split('/').reverse().join('-'))
    if (value.indexOf('_') < 0 && date.getDate()) {
      var date18 = new Date([date.getFullYear() + 18, date.getMonth() + 1, date.getDate()].join('-'));
    }
    if (date18 >= Date.now()) {
      this.setState({ showGuardianFields: true, guardian1: this.props.registrant.id });
    } else {
      this.setState({ showGuardianFields: false, guardian1: '', guardian2: '' });
    }
  }

  onCheck(e) {
    const state = this.state;
    state[e.target.id] = e.target.checked;
    this.setState(state);
  }

  checkFields() {
    if (this.state.password !== this.state.confirmPassword) {
      this.setState({ createErrorMessage: "Passwords don't match." });
      return false;
    } else if (!(new Date(this.state.dateOfBirth.split('/').reverse().join('-')).getDate())) {
      this.setState({ createErrorMessage: 'You must enter the Date of birth as dd/mm/yyyy.' });
      return false;
    } else {
      return true;
    }
  }

  handleSubmit(e) {
    e.preventDefault();
    if (this.checkFields()) {
      $.ajax({
          url: '/users',
          type: 'POST',
          async: false,
          data: { 
            user: {
              registrant_id: this.props.registrant.id,
              first_name: this.state.firstName,
              last_name: this.state.lastName,
              date_of_birth: this.state.dateOfBirth,
              email: this.state.email,
              password: this.state.password,
              allow_emailing: this.state.allowEmailing,
              phone: this.state.phone.replace(/\D/g,''),
              mobile: this.state.mobile.replace(/\D/g,''),
              allow_texting: this.state.allowTexting,
              guardian_1_id: this.state.guardian1,
              guardian_2_id: this.state.guardian2,
              trainer_id: this.state.coachedBy,
              sponsored_by: this.state.sponsoredBy,
              address_attributes: {
                line1: this.state.address1,
                line2: this.state.address2,
                city: this.state.city,
                province: this.state.province,
                postal_code: this.state.zipCode,
                addressable_id: this.props.registrant.id,
                addressable_type: "User"
              },
              equine_associations_attributes: this.state.memberships.filter(function(el) {return el.name !== "Select Organization"}),
              is_company: false
            }
          },
          success: (response) => {
            window.location = response.url
          },
          error: (response) => {
            this.setState({ createErrorMessage: response.responseJSON.join(", ") })
          }
      });
    }
  }

  handleDynamicFormNameChange(e, key) {
    var memberships = this.state.memberships;
    memberships[key].name = e;
    this.setState(memberships)
  }

  handleDynamicFormIdChange(e, key) {
    var memberships = this.state.memberships;
    memberships[key].number = e;
    this.setState(memberships)
  }

  handleAddForm() {
    var memberships = this.state.memberships;
    const organizationList = [I18n.t("equine_association.select"),
      "Ontario Equestrian",
      "Cheval Québec",
      "Alberta Equestrian Federation",
      "New Brunswick Equestrian Federation",
      "Horse Council of British Columbia",
      "Nova Scotia Equestrian Federation",
      "Island Horse Council",
      "Manitoba Horse Council",
      "Saskatchewan Horse Federation",
      "Newfoundland and Labrador Equestrian Association",
      "Equine Association of Yukon",
      "Ontario Hunter Jumper Association",
      "Trillium Hunter Jumper Association",
      "Foreign"].map(this.listToSelectOption);
    const key = this.state.forms.length + this.state.initialForms.length
    memberships[key] = {name: "", number: ""}
    this.setState(memberships)
    this.setState({
      forms: this.state.forms.concat([
        <DynamicMembershipForm
          key={key}
          keyId={key}
          fieldNames={[I18n.t("activerecord.attributes.equine_association.name"), I18n.t("activerecord.attributes.equine_association.number")]}
          organizationList={organizationList}
          onNameChange={this.handleDynamicFormNameChange}
          onIdChange={this.handleDynamicFormIdChange} />
      ])
    });
  }

  handleRemoveForm() {
    this.setState({ 
      forms: this.state.forms.slice(0,-1),
      memberships: this.state.memberships.slice(0,-1)
    });
  }

  handleCoachChange(e) {
    this.setState({ coachedBy: e })
  }

  handleGuardianOneChange(e) {
    this.setState({ guardian1: e })
  }

  handleGuardianTwoChange(e) {
    this.setState({ guardian2: e })
  }

  personAsOption(x) {
    return <option key={x.id} value={x.id}>{x.name}</option>;
  };

  render() {
    return (
      <div className="form-horizontal">
        <form onSubmit={this.handleSubmit}>
          <div className="row">
            <div className="span6" stylename="min-width: 420px;">
              <h4>
                <strong>
                  {I18n.t("exhibitor.person_information_label")}
                </strong>
              </h4>
              <div className="control-group string required first_name">
                <label className="string required control-label">
                  <abbr title="required">*</abbr> {I18n.t("activerecord.attributes.user.first_name")}
                </label>
                <div className="controls">
                  <input className="required" type="text" required="required" value={this.state.firstName} onChange={this.onChange} id="firstName"/>
                </div>
              </div>
              <div className="control-group string required last_name">
                <label className="string required control-label">
                  <abbr title="required">*</abbr> {I18n.t("activerecord.attributes.user.last_name")}
                </label>
                <div className="controls">
                  <input className="string required" type="text" required="required" value={this.state.lastName} onChange={this.onChange} id="lastName"/>
                </div>
              </div>
              <div className="control-group string required user_date_of_birth">
                <label className="string required control-label">
                  <abbr title="required">*</abbr> {I18n.t("activerecord.attributes.user.date_of_birth")}
                </label>
                <div className="controls">
                  <DatePicker handleDateChange={this.handleDateChange} formID='dateOfBirth' isRequired={true}/>
                </div>
              </div>
              <div className="control-group email required user_email">
                <label className="email required control-label">
                  <abbr title="required">*</abbr> {I18n.t("activerecord.attributes.user.email")}
                </label>
                <div className="controls">
                  <input className="string email required" required="required" title={I18n.t("exhibitor.create_person_popup_email")} type="email" value={this.state.email} onChange={this.onChange} id="email"/>
                </div>
              </div>
              <div className="control-group password required user_password">
                <label className="password required control-label">
                  <abbr title="required">*</abbr> {I18n.t("activerecord.attributes.user.password")}
                </label>
                <div className="controls">
                   <input className="password required" required="required" type="password" minLength="8"
                    value={this.state.password} onChange={this.onChange} id="password" />
                </div>
              </div>
              <div className="control-group password required user_password_confirmation">
                <label className="password required control-label">
                  <abbr title="required">*</abbr> {I18n.t("activerecord.attributes.user.password_confirmation")}
                </label>
                <div className="controls">
                  <input className="password required" required="required" type="password" minLength="8"
                   value={this.state.confirmPassword} onChange={this.onChange} id="confirmPassword" />
                </div>
              </div>
              <div className="control-group boolean optional user_allow_emailing">
                <label className="boolean optional control-label">{I18n.t("activerecord.attributes.user.allow_emailing")}</label>
                <div className="controls">
                  <input type="checkbox" checked={this.state.allowEmailing} onChange={this.onCheck} id="allowEmailing"/>
                  <p className="help-block"> {I18n.t("user.will_not_receive_email_warning")}</p>
                </div>
              </div>
              <div className="control-group tel optional user_phone">
                <label className="tel optional control-label" >{I18n.t("activerecord.attributes.user.phone")}</label>
                <div className="controls">
                  <InputMask className="string tel optional"  type="tel" value={this.state.phone} onChange={this.onChange} id="phone" mask={"(999)999-9999"}/>
                </div>
              </div>
              <div className="control-group string required user_mobile">
                <label className="string required control-label">
                  <abbr title="required">*</abbr> {I18n.t("activerecord.attributes.user.mobile")}
                </label>
                <div className="controls">
                  <InputMask className="string required" required="required" type="text" title={I18n.t("exhibitor.create_person_popup_mobile")} value={this.state.mobile} onChange={this.onChange} id="mobile" mask={"(999) 999-9999"}/>
                </div>
              </div>
              <div className="control-group boolean optional user_allow_texting">
                <label className="boolean optional control-label">{I18n.t("activerecord.attributes.user.allow_texting")}</label>
                <div className="controls">
                  <input type="checkbox" checked={this.state.allowTexting} onChange={this.onCheck} id="allowTexting"/>
                  <p className="help-block">{I18n.t("user.will_not_recieve_messages_warning")}</p>
                </div>
              </div>
              { 
                this.state.showGuardianFields ?
                <div>
                  <PersonSelect
                    personOptions={this.props.people.map(this.personAsOption)}
                    required={true}
                    label={I18n.t("user.parent_guardian", {number: 1})}
                    person={"guardian1"}
                    company={false}
                    handleChange={this.handleGuardianOneChange}
                    defaultValue={this.state.guardian1}
                  />
                  <div className="control-group">
                    <div className="controls">
                      <p className="help-block"> {I18n.t("exhibitor.parent_guardian_contact")}</p>
                    </div>
                  </div>
                  <PersonSelect
                    personOptions={this.props.people.map(this.personAsOption)}
                    required={false}
                    label={I18n.t("user.parent_guardian", {number: 2})}
                    person={"guardian2"}
                    company={false}
                    handleChange={this.handleGuardianTwoChange}
                  />
                </div>
                :undefined 
              }
              <PersonSelect
                personOptions={this.props.people.map(this.personAsOption)} 
                required={true}
                label={I18n.t("exhibitor.trained_by_label")}
                person={"coachedBy"}
                field={"coached_by"}
                company={false}
                handleChange={this.handleCoachChange}
              />
              <div className="control-group">
                <div className="controls">
                  <p className="help-block">
                    <i> {I18n.t("exhibitor.select_their_coach")}
                    </i>
                  </p>
                </div>
              </div>
              <div className="control-group text optional user_sponsored_by">
                <label className="text optional control-label">{I18n.t("activerecord.attributes.user.sponsored_by")}</label>
                <div className="controls">
                  <textarea className="text optional" value={this.state.sponsoredBy} onChange={this.onChange} id="sponsoredBy"/>
                </div>
              </div>
            </div>
            <div className="span6">
              <br/>
              <br/>
              <div className="control-group string required user_address_line1">
                <label className="string required control-label">
                  <abbr title="required">*</abbr> {I18n.t("activerecord.attributes.address.line1")}
                </label>
                <div className="controls">
                  <input className="string required" required="required" type="text" value={this.state.address1} onChange={this.onChange} id="address1"/>
                </div>
              </div>
              <div className="control-group string optional user_address_line2">
                <label className="string optional control-label">{I18n.t("activerecord.attributes.address.line2")}</label>
                <div className="controls">
                  <input className="string optional" type="text" value={this.state.address2} onChange={this.onChange} id="address2"/>
                </div>
              </div>
              <div className="control-group string required user_address_city">
                <label className="string required control-label" >
                  <abbr title="required">*</abbr> {I18n.t("activerecord.attributes.address.city")}
                </label>
                <div className="controls">
                  <input className="string required" required="required" type="text" value={this.state.city} onChange={this.onChange} id="city"/>
                </div>
              </div>
              <div className="control-group select required user_address_province">
                <label className="select required control-label">
                  <abbr title="required">*</abbr> {I18n.t("activerecord.attributes.address.province")}
                </label>
                <div className="controls">
                  <select required="required" value={this.state.province} onChange={this.onChange} id="province">
                    <option key="0"></option>
                    {this.props.provincess.map(this.listToSelectOption)}
                  </select>
                </div>
              </div>
              <div className="control-group string required user_address_postal_code">
                <label className="string required control-label">
                  <abbr title="required">*</abbr> {I18n.t("activerecord.attributes.address.postal_code")}
                </label>
                <div className="controls">
                  <input className="string required" required="required" type="text" value={this.state.zipCode} onChange={this.onChange} id="zipCode"/>
                </div>
              </div>
              <div>
                <strong>{I18n.t("equine_association.header")} </strong>
                {this.state.initialForms}
                {this.state.forms}
                {this.state.memberships.length > this.state.initialForms.length ?
                  <div>
                    <a className="btn btn-danger" onClick={this.handleRemoveForm}>{I18n.t("equine_association.remove")}</a>
                    <br/>
                    <br/>
                  </div>
                  : undefined}
                <a className="btn btn-success" onClick={this.handleAddForm}>{I18n.t("equine_association.add")}</a>
              </div>
            </div>
          </div>
          {this.state.createErrorMessage ? 
            <ErrorMessage message={this.state.createErrorMessage} />
            :undefined
          }
          <a className="btn btn-success" href="/">{I18n.t("home_link")}</a>
          <span> </span>
          <input className="btn btn-primary" type="submit" value={I18n.t("user.create_person_label")}/>
        </form>
      </div>
    );
  }
}
